import React, { memo, useState, useCallback } from 'react'
import { CirclePlusMajor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { CreateContractorFileModal } from './create-contractor-file/CreateContractorFileModal'
import { colors } from 'src/theme'

interface Props {
  contractorId: string
  onUpdate(): void
}

const CreateContractorFileButtonComponent = ({ contractorId, onUpdate }: Props) => {
  const [isCreateContractorFileModalOpen, setIsCreateContractorFileModalOpen] = useState(false)

  const openCreateContractorFileModal = useCallback(() => {
    setIsCreateContractorFileModalOpen(true)
  }, [])
  const closeCreateContractorFileModal = useCallback(() => {
    setIsCreateContractorFileModalOpen(false)
  }, [])

  return (
    <>
      <Button
        fullWidth
        color="light"
        size="small"
        onClick={openCreateContractorFileModal}
        endIcon={<CirclePlusMajor width={20} fill={colors.PRIMARY_PURPLE_500} />}
      >
        Add file
      </Button>
      <CreateContractorFileModal
        isOpen={isCreateContractorFileModalOpen}
        onClose={closeCreateContractorFileModal}
        contractorId={contractorId}
        onUpdate={onUpdate}
      />
    </>
  )
}

export const CreateContractorFileButton = memo(CreateContractorFileButtonComponent)
